import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getContactoVisitas`, method: 'GET', body: null, token: token})
}